<style scoped>

</style>

<template>
  <VModel
    v-model="config.modal"
    title="编辑"
    width="800"
    persistent
    :height-rate="0.6"
    dynamic-height
    :loading="config.loading"
    @ok="updateMapping"
  >
    <v-autocomplete
      v-model="edit_mapping.employment_type_id"
      label="用工类型"
      item-value="item_id"
      item-text="item_text"
      :items="employment_types"
    />
    <v-autocomplete
      v-model="edit_mapping.customer_function_id"
      label="职能"
      item-value="id"
      item-text="name"
      :items="customer_functions"
    />
    <v-autocomplete
      v-model="edit_mapping.employment_form_id"
      label="人员属性"
      :items="employment_forms"
      item-text="item_text"
      item-value="item_id"
    />

    <v-checkbox
      v-model="edit_mapping.research"
      label="研发项目"
    />
    <!-- <v-autocomplete

      :key="wage.key"
      v-model="edit_mapping[wage.key]"
      :label="`${wage.label}科目 ${titleNamesByTitleMapping(edit_mapping[wage.key])}`"
      item-value="id"
      :item-text="titleMappingText"
      :items="filter_title_mappings"
    /> -->
    <!-- <div v-if="filter_title_mappings.length">
      <v-autocomplete
        v-for="wage in wage_list"
        :key="wage.key"
        v-model="edit_mapping[wage.key]"
        :label="`${wage.label}科目 ${titleNamesByTitleMapping(edit_mapping[wage.key])}`"
        item-value="id"
        :item-text="titleMappingText"
        :items="filter_title_mappings"
      />
    </div> -->
  </VModel>
</template>

<script>
  import {mapGetters} from "vuex";
  import WAGE_LIST from '@/views/wage_title_mapping/constants/wage_list.js';
  import TitleMappingUtil from '@/views/wage_title_mapping/mixins/title_mapping_util.js';
  // import VModel from '../../../vuetify_custom/v-modal';
  import {postSalaryMappingSaveApi} from './service'
  import VModel from '@/vuetify_custom/v-modal_v1'
  const NEW_MAPPING = {
    customer_function_id: 0,
    customer_type:null,
    team_ids: [],
    job_ids: [],
  }

  WAGE_LIST.forEach(wage_item => {
    NEW_MAPPING[wage_item.key] = 0
  })
  const createParams = () => ({
    id: null,
    employment_type_id: null,
    employment_form_id: null,
    customer_function_id: null,
    research:false,
  })
  export default {
    components: { VModel },
    mixins: [TitleMappingUtil],
    data() {
      return {
        wage_list: WAGE_LIST,
        config: {
          modal: false,
          loading: false
        },
        edit_mapping: createParams()
      }
    },
    computed: {
      ...mapGetters('async', [
        'employment_types',
        'employment_forms',
        'root_teams',
        'team_jobs_hash',
        'customer_functions',
        'customer_functions_hash',
        'expense_natures_hash',
        'mapping_customer_types_hash',
        'item_types_hash',
        'fund_usages_hash',
        'title_mappings',
        'analysis_titles_hash',
        'account_titles_hash',
        'mapping_customer_types'
      ]),
      customer_types_c() {
        return this.mapping_customer_types.map(item => ({
          ...item,
          disabled: item.del
        }))
      },
      active_teams() {
        return this.root_teams // .filter(t => !t.del);
      },
      teams_jobs() {
        const jobs_hash = {};
        this.edit_mapping.team_ids.forEach((team_id) => {
          const team_jobs = this.team_jobs_hash[team_id] || [];
          team_jobs.forEach((job) => {
            jobs_hash[job.id] = job;
          })
        })
        return Object.values(jobs_hash);
      },
      filter_title_mappings() {
        return this.title_mappings.filter(m => m.customer_function_id === this.edit_mapping.customer_function_id)
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      titleMappingText(title_mapping) {
        let text = '';
        const expense_nature = this.expense_natures_hash[title_mapping.expense_nature_id];
        if (!expense_nature || expense_nature.del) return '错误选项，请不要选择';
        text += expense_nature.name;
        const customer_type = this.mapping_customer_types_hash[title_mapping.customer_type];
        if (customer_type) {
          text += `-${customer_type.label}`;
        }
        const item_type = this.item_types_hash[title_mapping.item_type_id];
        if (item_type) {
          text += `-${item_type.name}`;
        }
        const fund_usage = this.fund_usages_hash[title_mapping.fund_usage_id];
        if (fund_usage) {
          text += `-${fund_usage.name}`;
        }
        if (title_mapping.is_insider_trading) {
          text += '-内部交易';
        }
        return text;
      },
      edit(mapping) {
        const y = createParams()
        if (mapping) {
          Object.keys(y).forEach(key => {
            y[key] = mapping[key]
          })
        }
        this.edit_mapping = y;
        this.config.modal = true;
      },
      updateMapping() {
        this.config.loading = true;
        postSalaryMappingSaveApi(this.edit_mapping)
          .then(() => {
         
            this.config.modal = false;
            this.$Message.success('数据提交成功！')
            this.$emit('success')
          }).catch((e) => {
            console.warn(e);
          }).finally(() => {
            this.config.loading = false;
            // setTimeout(() => {
            //   this.config.loading = true;
            // }, 500);
          });
      }
    }
  }
</script>
